import React from 'react';
import { Row, Col, Button, Input, Select, Tooltip, Spin, Table, Icon } from 'antd';
import CatalogosRequest from '../../services/Catalogos';
import SitiosRequest from '../../services/Sitios';
import { openNotification } from '../../util/notificaciones';
import FormVariables from './FormVariables';
import PedidosRequest from '../../services/Pedidos';
import ResponsiveCard from '../Common/ResponsiveCard';
import BaseComponent from '../Common/BaseComponent';

const { Option } = Select;

/**
 * Clase para ver el proceso de modelo de variables
 */
export default class ModeloVariables extends BaseComponent {
    state = {
        arrSucursales: [],
        arrPlazas: [],
        arrSegmentos: [],
        sucursalSelected: null,
        plazaSelected: null,
        segmentoSelected: null,
        segmentoUsuario: null,
        filterText: "",
        disableDeleteFilters: true,
        disableApplyFilters: true,
        filtros: {
            busqueda: undefined,
            plazas_id: undefined,
            segmento: undefined,
            page: 1
        },
        selectedRowKeys: [],
        selectedRows: [],
        cargando: false,
        paginacion: {},
        tipo_modal: "",
        sitioSelected: null,
        modo: "ver",
        plazasFiltradas: [],
    }

    /**
     * Función que se ejecuta se cargan los datos
     */
    componentDidMount = () => {
        let state = { ...this.state }
        this.setState({ cargando: true }, () => {
            CatalogosRequest.ListarSucursales().then(response => {
                state.arrSucursales = response.data;
                if (['Administrador', 'SuperAdmin'].includes(localStorage.getItem("role"))) {
                    return CatalogosRequest.ListarSegmentosConfigurados();
                } else {
                    return PedidosRequest.ListarSitiosSupervisor();
                }
            }).then(response => {
                if (['Administrador', 'SuperAdmin'].includes(localStorage.getItem("role"))) {
                    state.arrSegmentos = response.data;
                } else {
                    if (response.data.segmento) {
                        state.segmentoUsuario = response.data.segmento;
                    } else {
                        openNotification(
                            "El usuario no tiene asignado ningún segmento.",
                            "Error al cargar segmentos del usuario",
                            false,
                        );
                        throw new Error("Error al cargar segmentos del usuario");
                    }
                }
                return CatalogosRequest.ListarPlazas();
            }).then(response => {
                state.arrPlazas = response.data
                this.setState(state, this.filtrarBack)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al listar las sucursales y plazas.",
                    "Error al listar sucursales y plazas",
                    false
                )
            })
        })
    }

    /**
     * Función que se ejecuta cuando se cambia la sucursal
     * @param: value. valor de el id de la sucursal
     * @return: nada.
     */
    handleChangeSucursal = value => {
        let state = { ...this.state }
        state.plazasFiltradas = [];
        state.plazaSelected = null;
        state.filtros.plazas_id = undefined
        if (typeof value === 'undefined') {
            state.sucursalSelected = null;
            state.disableDeleteFilters = true;
            state.disableApplyFilters = true
        } else {
            state.sucursalSelected = value;
            state.plazasFiltradas = state.arrPlazas.filter(item => item.sucursal === value)
            state.disableDeleteFilters = false;
            state.disableApplyFilters = false
        }

        this.setState(state);
    }

    /**
     * Función que se ejecuta cuando se cambia la plaza
     * @param: value. valor de el id de la plaza
     * @return: nada.
     */
    handleChangePlaza = value => {
        let state = { ...this.state }
        if (typeof value === 'undefined') {
            state.plazaSelected = null;
        } else {
            state.plazaSelected = value;
        }
        this.setState(state);
    }

    /**
     * Función que se ejecuta cuando se cambia el segmento
     * @param: value. valor de el id del segmento
     * @return: nada.
     */
    handleChangeSegmento = value => {
        let state = { ...this.state }
        if (typeof value === 'undefined') {
            state.segmentoSelected = null;
            state.disableDeleteFilters = true;
            state.disableApplyFilters = true;
        } else {
            state.segmentoSelected = value;
            state.disableDeleteFilters = false;
            state.disableApplyFilters = false;
        }
        this.setState(state);
    }
    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        let buscar = false;

        if (value.trim() === "" && state.sucursalSelected === null) {
            state.disableApplyFilters = true
            state.disableDeleteFilters = true
        }

        if (value.trim() !== state.filterText.trim()) buscar = true
        state.filterText = value;
        state.filtros.busqueda = value.trim() === "" ? undefined : value.trim()
        this.setState(state);

        if (buscar) {
            clearTimeout(state.timer)
            state.timer = setTimeout(() => {
                this.filtrarBack();
            }, 1000);
        }
    }

    /**
     * Funcion interna de ant para el manejo de los checkbox
     * @param: selectedRowKeys (la necesita ant): id de los renglones, selectedRows: toda la informacion del objeto seleccionado
     * @return: nada
     */
    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRowKeys, selectedRows });
    };

    /**
     * Función que se ejecuta cuando se da clic en página siguiente
     * @param: paginaSiguiente. valor de la página siguiente
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    handlePaginaChange = (paginaSiguiente) => {
        let state = { ...this.state };
        if (state.sucursalSelected === null) {
            state.filtros.plazas_id = undefined
        } else {
            if (state.plazaSelected === null) {
                state.filtros.plazas_id = state.plazasFiltradas.map(item => item.id).toString()
            } else {
                state.filtros.plazas_id = state.plazaSelected
            }
        }
        for (var key in state.filtros) {
            if (state.filtros[key] === null || state.filtros[key] === undefined) {
                delete state.filtros[key];
            }
        }

        state.filtros.page = paginaSiguiente
        state.cargando = true
        this.setState(state, () => {
            SitiosRequest.ListarSitios(state.filtros).then(response => {
                state.arrSitios = response.data.results
                state.cargando = false
                state.paginacion.current = paginaSiguiente
                this.setState(state)
            }).catch(err => {
                this.setState({ cargando: false })
                openNotification("Ha ocurrido un error al listar los sitios.", "Error al listar sitios", false)
            })
        })
    }

    /**
     * Función que se encarga de hacer las peticion en el back para filtrar
     * por los siguientes valores : 
     * {empresa: int, categoria:int, 
     *  subcategoria:int estatus:bool, 
     *  categorizado:bool, 
     *  nombre/codigo:string/int
     *  }
     */
    filtrarBack = () => {
        let state = { ...this.state };
        if (state.sucursalSelected === null) {
            state.filtros.plazas_id = undefined
        } else {
            if (state.plazaSelected === null) {
                state.filtros.plazas_id = state.plazasFiltradas.map(item => item.id).toString()
            } else {
                state.filtros.plazas_id = state.plazaSelected
            }
        }

        if (['Administrador', 'SuperAdmin'].includes(localStorage.getItem("role"))) {
            if (state.segmentoSelected === null) {
                state.filtros.segmento = undefined
            } else {
                state.filtros.segmento = state.segmentoSelected;
            }
        } else {
            if (state.segmentoUsuario === null) {
                state.filtros.segmento = undefined
            } else {
                state.filtros.segmento = state.segmentoUsuario;
            }
        }

        for (var key in state.filtros) {
            if (state.filtros[key] === null || state.filtros[key] === undefined) {
                delete state.filtros[key];
            }
        }

        state.filtros.page = 1;
        state.cargando = true;
        state.disableApplyFilters = true
        state.disableDeleteFilters = true
        this.setState(state, () => {
            SitiosRequest.ListarSitios(state.filtros).then(response => {
                state.arrSitios = response.data.results
                state.cargando = false
                if (state.sucursalSelected !== null || state.segmentoSelected !== null) {
                    state.disableDeleteFilters = false
                    state.disableApplyFilters = false
                }
                if (state.filterText !== "") {
                    state.disableDeleteFilters = false
                }
                state.paginacion = {
                    current: 1,
                    total: response.data.count,
                    onChange: this.handlePaginaChange,
                    pageSize: 10,
                    showTitle: false
                }
                this.setState(state)
            }).catch(err => {
                this.setState({ cargando: false })
                openNotification("Ha ocurrido un error al listar los sitios.", "Error al listar sitios", false)
            })
        })
    }

    /**
    * Función para limpiar todos los filtros que han
    * sido manipulados por el usuario.
    * @param: nada
    * @return: nada
    */
    cleanFilters = () => {
        let state = { ...this.state }
        state.disableApplyFilters = true;
        state.disableDeleteFilters = true;
        state.filtros.busqueda = undefined;
        state.filtros.plazas_id = undefined;
        state.filtros.segmento = undefined;
        state.filtros.page = 1;
        state.sucursalSelected = null;
        state.plazaSelected = null;
        state.segmentoSelected = null;
        state.filterText = "";
        state.plazasFiltradas = [];
        this.setState(state, this.filtrarBack);
        openNotification("Los filtros se han limpiado correctamente.", "Filtros limpiados correctamente", true);
    }

    /**
     * Función que se ejecuta cuando se muestra el modal
     * @param: tipo. valor del tipo de modal
     * @return: nada.
     */
    showModal = (tipo) => {
        this.setState({ modalFormVariables: true, sitioSelected: null, tipo_modal: tipo })
    }

    /**
     * Función que se ejecuta cuando se cambia la sucursal
     * @param: value. valor para esconder modal 
     * @return: nada.
     */
    esconderModal = (value) => {
        this.setState({ modalFormVariables: false, sitioSelected: null })
    }

    render() {
        const categoria = this.props.location.state.categoria;
        const modelo = this.props.location.state.modelo;
        const columnasSitios = [
            {
                title: "CR",
                dataIndex: "cr",
                key: "cr"
            },
            {
                title: "Nombre PV",
                dataIndex: "nombre",
                key: "nombre"
            },
            {
                title: "Plaza",
                dataIndex: "plaza_nombre",
                key: "plaza_nombre"
            }, {
                title: 'Acciones',
                dataIndex: 'Acciones',
                key: 'Acciones',
                render: (value, record) => (
                    <div>
                        <div>
                            <span style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Ver variable del sitio"}>
                                    <Button
                                        id="boton-ver-variables-tabla"
                                        icon="eye"
                                        className="btnVerCrearGuardar"
                                        onClick={() => {
                                            this.setState({
                                                sitioSelected: record,
                                                modo: "ver"
                                            }, this.showModal("Uno"))
                                        }}
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                            <span className={localStorage.getItem("role") === 'Coordinador de Operaciones Drive' ? 'display-none' : ''} style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Editar variables del sitio"}>
                                    <Button
                                        id="boton-editar-variables-tabla"
                                        icon="edit"
                                        className="btnEditar"
                                        onClick={() => {
                                            this.setState({
                                                sitioSelected: record,
                                                modo: "editar",
                                            }, this.showModal("Uno"))
                                        }}
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                        </div>
                    </div>
                )
            }
        ]
        const { selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
            hideDefaultSelections: true,
            selections: [
                {
                    key: 'all-data',
                    text: 'Seleccionar todo',
                    onSelect: () => {
                        if (this.state.arrSitios.length) {
                            this.setState({
                                selectedRowKeys: this.state.arrSitios.map(item => item.id),
                                selectedRows: [...this.state.arrSitios]
                            });
                        }

                    },
                },
                {
                    key: 'un-select-all',
                    text: 'Deseleccionar todo',
                    onSelect: changableRowKeys => {
                        this.setState({ selectedRowKeys: [], selectedRows: [] });
                    },
                }
            ],
        };
        return (
            <ResponsiveCard id="ParentSize"
                title="Módulo modelo de pedido"
                extra={
                    <div>
                        <Button
                            id="boton-atras-variables"
                            className="btnCancelar"
                            key="back"
                            style={{ marginRight: 10 }}
                            onClick={() => {
                                this.props.history.goBack()
                            }}
                        >
                            Atrás
                        </Button>
                            <Tooltip placement="top" title="Editar variables" className={localStorage.getItem("role") === 'Coordinador de Operaciones Drive' ? 'display-none' : ''}>
                                <Button
                                    type="primary"
                                    id="boton-editar-variables"
                                    disabled={this.state.selectedRowKeys.length < 2}
                                    onClick={() => {
                                        this.setState({
                                            modo: "editar",
                                            tipo_modal: "Muchos"
                                        }, this.showModal("Muchos"))
                                    }}
                                >
                                    Editar variables
                                </Button>
                            </Tooltip>
                    </div>
                }
            >
                <div className="panel-block">
                    <div style={{ marginBottom: this.state.isPos ? 0 : 10 }}>
                        <Row gutter={10}>
                            <Col span={5}>
                                <div className="center">Modelo:</div>
                                <Input
                                    id="input-modelo-variables"
                                    type="text"
                                    value={modelo}
                                    className='disableBtn'
                                />
                            </Col>
                            <Col span={5}>
                                <div className="center">Categoría:</div>
                                <Input
                                    id="input-categoria-variables"
                                    type="text"
                                    value={categoria}
                                    className='disableBtn'
                                />
                            </Col>
                            <Col className={['Administrador', 'SuperAdmin'].includes(localStorage.getItem("role")) ? '' : 'display-none'} span={7}>
                                <Tooltip placement="top" title="Buscar punto de venta por segmento">
                                    <div className="center">Segmento:</div>
                                    <Select
                                        id="select-segmento-variables"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        value={this.state.segmentoSelected}
                                        optionFilterProp="children"
                                        onChange={this.handleChangeSegmento}
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrSegmentos.length > 0 &&
                                            this.state.arrSegmentos.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={7}>
                                <Tooltip placement="top" title="Buscar punto de venta por sucursal">
                                    <div className="center">Sucursal:</div>
                                    <Select
                                        id="select-sucursal-variables"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        value={this.state.sucursalSelected}
                                        optionFilterProp="children"
                                        onChange={this.handleChangeSucursal}
                                        disabled={this.state.segmentoSelected === null}
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrSucursales.length > 0 &&
                                            this.state.arrSucursales.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                        </Row> <br />
                        <Row gutter={10}>
                            <Col span={5}>
                                <Tooltip placement="top" title="Buscar punto de venta por plaza">
                                    <div className="center">Plaza:</div>
                                    <Select
                                        id="select-plaza-variables"
                                        showSearch
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        style={{ width: "100%" }}
                                        value={this.state.plazaSelected}
                                        defaultValue={null}
                                        placeholder="Buscar por sucursal"
                                        optionFilterProp="children"
                                        disabled={this.state.sucursalSelected === null}
                                        onChange={this.handleChangePlaza}
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.plazasFiltradas.length > 0 &&
                                            this.state.plazasFiltradas.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={['Administrador', 'SuperAdmin'].includes(localStorage.getItem("role")) ? 12 : 10} >
                                <Tooltip placement="top" title="Buscar puntos de venta">
                                    <div className="center">Buscar puntos de venta:</div>
                                    <Input
                                        id="input-puntos-venta-busqueda"
                                        type="text"
                                        maxLength={80}
                                        autoFocus
                                        value={this.state.filterText}
                                        placeholder="Buscar por CR / Nombre"
                                        onChange={(e) => this.filterText(e.currentTarget.value)}
                                    />
                                </Tooltip>
                            </Col>
                            <Col span={2}>
                                <Tooltip placement="top" title={this.state.sucursalSelected !== null ? "Realizar búsqueda" : ""}>
                                    <Button
                                        id="boton-filtrar-variables"
                                        className={this.state.disableApplyFilters ? "disableBtn" : ""}
                                        type={this.state.disableApplyFilters ? "default" : "primary"}
                                        icon="search"
                                        style={{ width: '80%', marginBottom: "30px", marginTop: '1.85em' }}
                                        onClick={this.filtrarBack}
                                    >
                                    </Button>
                                </Tooltip>
                            </Col>
                            <Col span={2}>
                                <Tooltip placement="top" title="Borrar filtros">
                                    <Button
                                        id="boton-borrar-filtros-variables"
                                        type="default"
                                        icon="delete"
                                        className={this.state.disableDeleteFilters ? 'disableBtn' : ''}
                                        style={{ width: '80%', marginBottom: "30px", marginTop: '1.85em' }}
                                        onClick={this.cleanFilters}
                                    >
                                    </Button>
                                </Tooltip>
                            </Col>
                        </Row>
                    </div>
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={sitio => sitio.id}
                            columns={columnasSitios}
                            dataSource={this.state.arrSitios}
                            rowSelection={rowSelection}
                            pagination={this.state.paginacion}
                        />
                    </Spin>
                </div>
                <FormVariables
                    esconderModal={this.esconderModal}
                    visible={this.state.modalFormVariables}
                    arrSitios={this.state.selectedRowKeys}
                    sitio_selected={this.state.sitioSelected}
                    tipo_modal={this.state.tipo_modal}
                    modo={this.state.modo}
                    categoria={this.props.location.state.categoria_id}
                    categoria_nombre={this.props.location.state.categoria}
                    modelo={this.props.location.state.modelo_id}
                >
                </FormVariables>
            </ResponsiveCard>
        )
    }
}